
export const isUUID=(str)=>{
  // Regular expression pattern for UUIDv4
  const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  // Test the string against the UUIDv4 pattern
  return uuidPattern.test(str);
}


export const PortfolioTypes = {
        b: 'Block',
        s: "Sleeve",
        m: "Model",
     mm: "Model of Models"
}


export const portfolioTypeString = (type)=>{
    return PortfolioTypes[type]
}


let capitalize = (string)=>{
    let head = string.slice(0, 1).toString();
    return `${head.toUpperCase()}${string.slice(1, ).toString().toLowerCase()}`
}



export const money = (amount, decimalCount = 2, decimal='.', thousands=',', center=true) => {
    let val;
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        const negativeSign = amount < 0 ? "-" : "";
        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;
        val = '$' + negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        val = '$' + amount;
    }
    if (center === true) {
        return val;
    }
    else {
        return val;
    }
}


/** Mixin methods for working with strings (converting numbers to strings, formatting strings, etc..) */
let stringMixin = {
    date(d, {
        asString=false,
        keepTime=false,
        fmt='YYYYMMDD',
        sep='-'
    }={}){
        let parts = d.split(sep);
        let ret = null;
        if (fmt==='YYYYMMDD'){
            ret = new Date(`${parts[1]}/${parts[2]}/${parts[0]}`);
        }
        if (ret!==null){
            if (asString){
                ret = ret.toISOString();
                if (!keepTime){
                    ret = ret.split('T')[0].toString();
                }
            }
        }
        return ret;

    },

    fmt(string, {
        cap=true,
        allCaps=false,
        maxSize=null,
        sep=' '}={}){
        let returnString = "";
        let appendString = (_string)=>{
            if (allCaps===true){
                _string.toUpperCase()
            }
            else {
                _string = capitalize(_string);
            }
            returnString += `${_string}${sep}`
        }
        try {
            string = string.replace(/[/\s-._\/]/g, '|'); // Standardize characters to split on
            if (string.includes('|')) {
                string.split('|').forEach(x => {
                    appendString(x);
                });
                return returnString;
            } else {
                return allCaps === true ? string.toUpperCase() : capitalize(string)
            }
        }
        catch(e){
            return returnString
        }
    },

    largeNumber(v, prec){
        let isNegative = v < 0;
        let display = v

        try {
            let no = Math.abs(parseFloat(v.toString()));
            if (no < 1e6) {
                no = parseFloat(no.toFixed(0));
                display = money(no, 0).slice(1,).toString();
            }
            else if (no < 1e9) {
                display = (no / 1e6).toFixed(1).toString() + 'M';
            }
            else if (no < 1e12) {
                display = (no / 1e9).toFixed(1).toString() + 'B';
            }
            else if (no < 1e15) {
                display = (no / 1e12).toFixed(1).toString() + 'T';
            }

        }
        catch(err) {}

        return isNegative === true ? `(${display})` : display;

    },


    percentage(v, {
        addArrow=true,
        appendArrow=false,
        mult=100,
        prec=2,
        postfix='%'
    }={}){
        if (v !== 0){
            v *= mult;
        }
        v = parseFloat(v);
        if (isNaN(v)){
            v = 0;
        }
        if (addArrow===true){
            let padding = appendArrow === false ? 'pr-1' : 'pl-1';
            let arrow = v > 0 ? `<i class="fa-solid fa-caret-up green ${padding}"></i>` : `<i class="fa-solid fa-caret-down red ${padding}"></i>`;
            if (v===0){
                arrow = `<i class="fa-solid fa-caret-right grey ${padding}"></i>`
            }
            return appendArrow===false ? arrow + Math.abs(v).toFixed(prec) + postfix : v.toFixed(prec) + postfix + arrow;
        }
        return v.toFixed(prec) + postfix;
    },

    pct(v, {mult=100, prec=2}={}){
        return this.percentage(v, {mult: mult, prec: prec, addArrow: false});
    },

    phoneNumber(phone){
        let cleaned = ('' + phone).replace(/\D/g, '');
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        return '';
    },


    sectype(type){
        type.toLowerCase();
        if (type==='stock'){
            return "Stock"
        }
        else if (type === 'etf'){
            return "ETF"
        }
        else if (type === 'fund'){
            return "Fund"
        }

    },


    timestamp(delta, {sub=true}={}) {

        let baseTime = Date.now() / 1000;
        let nd = delta
        if (sub===true) {
            nd = baseTime - delta;
        }
        delta = nd;

        if (delta <  60) {
            return `${delta.toFixed(1)} Sec`;
        }
        if (delta <  60 * 60) {
            return `${Math.floor(delta / 60).toString()} Min`;
        }
        else if (delta < 60 * 60 * 24) {
            let h = Math.floor((delta / (60 * 60)));
            return h.toString() + (h === 1 ? ' Hour' : ' Hours')
        }
        else if (delta < 60 * 60 * 24 * 7) {
            let d = Math.floor((delta / (60 * 60 * 24)));
            return d.toString() + (d === 1 ? ' Day' : " Days")
        }
        else if (delta < 3600 * 24 * 7 * 30) {
            let w = Math.floor((delta / (60 * 60 * 24 * 7)))
            return w.toString() + (w === 1 ? ' Week' : ' Weeks')
        }
    }

}



function findTickersInText(textBody, tickerSymbols) {
  const lowerCaseText = textBody.toLowerCase();
  const foundTickers = [];

  for (const ticker of tickerSymbols) {
    const lowerCaseTicker = ticker.toLowerCase();
    if (lowerCaseText.includes(lowerCaseTicker)) {
      foundTickers.push(ticker); // Keep original casing
    }
  }

  return foundTickers;
}

export {stringMixin, capitalize, findTickersInText}